import React, {Component} from "react";
import {
  clearTokens,
  getRefreshToken,
  getStoredUser,
  ROLES,
} from "./api-client/core/authentication/utils";
import {request} from "./api-client";
import loggedOff from "./routes/roles/loggedOff";
import sysadminRoutes from "./routes/roles/sysadmin";
import userRoutes from "./routes/roles/user";
import renderRoutes from "./routes/roles/renderRoutes";
import analyticsInstance from "./analytics/analyticsInstance";
import AnalyticsBuilder from "./analytics/src/AnalyticsBuilder";
import EventManager, {events} from "./utils/EventManager";
import GlobalSnackbar from "./components/Letflow/Snackbar/GlobalSnackbar";
import FreshChat from "./utils/FreshChat";
import GlobalConfirmationDialog from "./components/Letflow/Dialog/GlobalConfirmationDialog";
import localization from "./config/localization";
import GlobalAddToPlaylistDialog from "./components/Letflow/AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import FavoritesAnalyticsHandler from "./utils/FavoritesAnalyticsHandler";
import browserHistory from "./utils/browserHistory";
import TermsOfUseDialog from "./components/Letflow/TermsOfUseDialog";
import projectInviteeRoutes from "./routes/roles/projectInvitee";
import ScrollMemory from "react-router-scroll-memory";
import {BrowserRouter} from "react-router-dom";
import BloomSpinner from "assets/img/bloom_spinner_grey.gif";
// Datepicker styles
import "react-datepicker/dist/react-datepicker.css";
// Template styles
import "assets/scss/material-dashboard-pro-react.css?v=1.2.0";
import GlobalRedirectLoginConfirmationDialog from "./components/Letflow/Dialog/GlobalRedirectLoginConfirmationDialog";
import ErrorBoundary from "./components/Letflow/ErrorBoundary";

class App extends Component {
  state = {
    routes: null
  };

  constructor() {
    super();
    this.favoritesAnalyticsHandler = new FavoritesAnalyticsHandler();
  }

  componentWillMount() {
    if(!localStorage.getItem("keepLogged")) {
      localStorage.setItem("keepLogged", "keep")
    }
  }

  componentDidMount = () => {
    this.initializeAnalytics();
    this.checkDomain()
      .then(() => {
        this.initializeSession();
        this.favoritesAnalyticsHandler.subscribe();
    });
  };

  componentWillUnmount = () => {
    this.favoritesAnalyticsHandler.unsubscribe();
  };

  checkDomain = () =>
    new Promise(resolve => {
        if (!localStorage.getItem("default_language")) {
          localStorage.setItem("default_language", window.domainLanguage)
        }
        localization.setLanguage(localStorage.getItem("default_language"))

      resolve()
   })

  initializeAnalytics = () => {
    const analytics = new AnalyticsBuilder()
      .withGoogleAnalytics(process.env.REACT_APP_GA_ACCOUNT)
      .withFlowlike()
      .build();

    analytics.initialize();
    analyticsInstance.set(analytics);
  };

  initializeSession = () => {
    if (!getRefreshToken()) {
      FreshChat.anonymous();

      this.setState({routes: loggedOff})
    } else {
      this.requestUser()
        .then(() => {
          localization.setDefaultLanguage();
          localization.setMomentLocale();
        })
        .then(this.setRoutesFromUser)
        .catch(this.handleRequestFailure)
    }
  };

  requestUser = () => request.authentication.getUser();

  setRoutesFromUser = () => {
    const user = getStoredUser();

    FreshChat.loggedIn(
      user.id,
      user.name,
      user.email,
      user.role && user.role.id,
    );

    const isSupervisor = ROLES.isSupervisor(user);
    const isSysAdmin = ROLES.isSysAdmin(user);
    const isProjectInvitee = ROLES.isProjectInvitee(user);
    const isUser = ROLES.isUser(user);

    let routes;
    if (isSysAdmin || isSupervisor) {
      routes = sysadminRoutes;
    } else if (isProjectInvitee) {
      routes = projectInviteeRoutes;
    } else if (isUser) {
      routes = userRoutes;
    }

    if (!routes) {
      throw new Error(`user does not have a valid role: ${user.role.id}`);
    }

    this.setState({ routes });
  };

  handleRequestFailure = e => {
    FreshChat.anonymous();
    clearTokens()
    window.location.reload()
  };

  render = () => {
    const { routes } = this.state;

    const makeContent = () => (
      <BrowserRouter>
        <ErrorBoundary>
          <div>
            <ScrollMemory />
            <div style={{ height: "100%", width: "100%" }}>
              {/*<TermsOfUseDialog />*/}
              <GlobalSnackbar />
              <GlobalConfirmationDialog />
              <GlobalAddToPlaylistDialog />
              <GlobalRedirectLoginConfirmationDialog />
              {renderRoutes(routes)}
            </div>
          </div>
        </ErrorBoundary>
      </BrowserRouter>
    );

    if (!routes) {
      return (
        <div
          style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}
        >
          <img style={{width: 100, height: 100, marginTop: "45vh"}} src={BloomSpinner} alt="Loading logo"/>
        </div>
      );
    }

    return makeContent();
  };
}

export default App;
